// extracted by mini-css-extract-plugin
export var fadeInOut = "_r-3";
export var icon = "_r-4";
export var savedIndicator = "_r-2";
export var savingIndicator = "_r-0";
export var spin = "_r-1";